/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PreviewInputs */

const en_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview`)
};

const es_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa`)
};

const fr_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

const de_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau`)
};

const ja_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビュー`)
};

const zh_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览`)
};

const ar_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة`)
};

const id_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau`)
};

const it_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima`)
};

const ru_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпросмотр`)
};

const pt_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualizar`)
};

const ko_preview = /** @type {(inputs: PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미리보기`)
};

/**
* | output |
* | --- |
* | "Preview" |
*
* @param {PreviewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const preview = /** @type {((inputs?: PreviewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PreviewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_preview(inputs)
	if (locale === "es") return es_preview(inputs)
	if (locale === "fr") return fr_preview(inputs)
	if (locale === "de") return de_preview(inputs)
	if (locale === "ja") return ja_preview(inputs)
	if (locale === "zh") return zh_preview(inputs)
	if (locale === "ar") return ar_preview(inputs)
	if (locale === "id") return id_preview(inputs)
	if (locale === "it") return it_preview(inputs)
	if (locale === "ru") return ru_preview(inputs)
	if (locale === "pt") return pt_preview(inputs)
	return ko_preview(inputs)
});